import { render, staticRenderFns } from "./AccountingAccountsTable.vue?vue&type=template&id=c883d2e6&"
import script from "./AccountingAccountsTable.vue?vue&type=script&lang=js&"
export * from "./AccountingAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports